const ABFieldTextFormulaCore = require("../../core/dataFields/ABFieldTextFormulaCore");
module.exports = class ABFieldTextFormula extends ABFieldTextFormulaCore {};
